import { reactive } from '../compat/vueCompat';

export interface LocalDownloadState {
  downloadPath: string;
  sharedDownloadPath?: string;
}


export const localDownloadState: LocalDownloadState = reactive({
  downloadPath: '',
  sharedDownloadPath: undefined,
});

